export const dashboardLocales = {
  approvalPending: "Approval Pending",
  approvalPendingStar: "* Only displays latest 10 pending requests.",
  email: "Email ID",
  jobs: {
    jobs: "Jobs",
    cardDescription:
      "View, Approve, Reject, List Request and Assign applicants sent offer letter, Edit jobs before publishing etc.",
    JobApplication: "Job Application",
    jobCancellation: "Job Cancellation",
  },
  jobId: "Job ID",
  jobCategory: "Job Category",
  jobDate: "Job Date",
  location: "Location",
  office: {
    office: "DSO / Private Office",
    cardDescription:
      "View, Add, Edit, Approve, Reject, Enable/Disable DSO/ Private Office accounts etc. and reset passwords.",
    nameOfDso: "Name of DSO/Private",
  },
  next: "Next",
  noDataINApprovalPending: "No new requests awaiting approval.",
  noApplicationsToDisplay: "No applications to display.",
  previous: "Previous",
  professional: {
    nameOfProfessional: "Name of professional",
    professional: "Professional",
    cardDescription:
      "View, Add, Edit, Approve, Reject, Offer Letter etc. for Dental Professional accounts.",
  },
  state: "State",
  viewAll: "View All",
  view: "View",
  welcomeToDentalDynamicStaffing: "Welcome to Dental Dynamic Staffing!",
  cancellation: "Cancellation",
};
